import styled from 'styled-components';
import materialUI from '../../material-UI';

export const Drop = styled(materialUI.Backdrop)``;
export const CircularProgress = styled(materialUI.CircularProgress)``;
